import { GenerationType, NodeType, ResponseBase, GenerationUserStory } from '../types';

export const metaDataDefaults: ResponseBase = {
  createdDate: 0,
  modifiedDate: 0,
  createdBy: '',
  modifiedBy: '',
  recDeleted: false,
  orgId: '',
  appId: '',
  sid: '',
  skipFieldsForValidation: null
};

export const generationUserStoryDefaults: GenerationUserStory = {
  type: NodeType.USER_STORY,
  name: '',
  shortName: '',
  description: null,
  parentNodeSid: null,
  previousNodeSid: null,
  aiConfidence: null,
  identifier: null,
  source: null,
  referredRoles: [],
  generationType: GenerationType.MANUAL,
  approvalStatus: 'APPROVED',
  generationId: '',
  placeholder: false,
  priority: 1,
  complexity: 1,
  moscow: 'MUST',
  scope: 'IN',
  estimation: 0,
  preConditions: null,
  basicFlow: null,
  alternateFlows: null,
  successCriteria: null,
  automationSuggestion: null,
  agentSuggestion: null,
  workflowStage: null,
  usageFrequency: 'Monthly',
  dataImpact: 'None',
  cognitiveLoad: 'Low',
  dirty: false,
  module: null,
  summary: null,
  automation: false,
  acceptanceCriteria: null
};
